import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";

// Import Bootstrap CSS first (if not imported in your main index file)
import "bootstrap/dist/css/bootstrap.min.css";
// Then import your custom CSS
import "./Login.css";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Dummy credentials (for testing purposes, replace with actual auth logic)
  const validCredentials = [{ email: "demo@fyled.ai", password: "demo@123" }];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    setTimeout(() => {
      const matchedUser = validCredentials.find(
        (user) => user.email === email && user.password === password
      );

      if (matchedUser) {
        // Save login state to localStorage
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userEmail", email);

        login(email); // Update context + localStorage
        toast.success("Login successful! Welcome back.", {
          position: "bottom-right",
          autoClose: 3000,
        });
        navigate("/ketcher");
      } else {
        setError("Invalid email or password. Please try again.");
      }

      setLoading(false);
    }, 1000);
  };

  return (
    <Container className="login-container py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6} xl={5}>
          <Card className="login-card shadow">
            <Card.Body>
              <div className="text-center mb-4">
                <img
                  src={`/fyled.png`}
                  alt="Fyled AI Logo"
                  width="60"
                  height="60"
                  className="mb-3"
                />
                <h2 className="fw-bold">Welcome Back</h2>
                <p className="text-muted">Sign in to access your account</p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 py-2"
                  disabled={loading}
                >
                  {loading ? "Signing in..." : "Sign In"}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
